<template>
  <v-row class="suburb-trends-with-notes-row" align="stretch" no-gutters>
    <!-- LEFT: suburb trends (two charts) -->
    <v-col cols="12" md="6" class="suburb-trends-col">
      <div class="suburb-trends-wrapper">
        <suburb-trends-section
          :property-id="propertyId"
          :suburbTrends="suburbTrends"
          :type="type"
        />
      </div>
    </v-col>

    <!-- RIGHT: notes -->
    <v-col cols="12" md="6" class="suburb-notes-col">
      <base-better-notes
        v-if="notesId"
        :id="notesId"
        :field-name="fieldName"
        :query="query"
        class="suburb-notes-component"
      />
    </v-col>
  </v-row>
</template>

<script>
import SuburbTrendsSection from "@/components/Base/Property/PropertyLanding/SuburbTrendsSection.vue";

export default {
  name: "SuburbTrendsWithNotes",
  components: {
    SuburbTrendsSection,
  },
  props: {
    propertyId: {
      type: [String, Number],
      default: null,
    },
    suburbTrends: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "Freehold",
    },
    notesId: {
      type: [String, Number],
      required: true,
    },
    fieldName: {
      type: String,
      default: "notes",
    },
    query: {
      type: String,
      default: "property",
    },
  },
};
</script>

<style scoped>
/* Make the row stretch both columns to the same height */
.suburb-trends-with-notes-row {
  width: 100%;
  align-items: stretch;
  margin-left: 0;
  margin-right: 0;
  background-color: transparent;
}

/* Each column is a flex container so its child can fill the height */
.suburb-trends-col,
.suburb-notes-col {
  display: flex;
  flex-direction: column;
}

/* LEFT: wrapper around the SuburbTrendsSection */
.suburb-trends-wrapper {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

/* Make the root element inside SuburbTrendsSection stretch as well */
.suburb-trends-wrapper > * {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

/* RIGHT: BetterNotes already renders a v-card.new-note-card.
   Force that card to fill the column height. */
.suburb-notes-component.v-card.new-note-card,
.suburb-notes-col .v-sheet.v-card.new-note-card {
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Give all cards slightly rounded corners and add the horizontal gap
   between the graphs card and the notes card via margins. */
.suburb-trends-wrapper .v-card {
  border-radius: 10px;
  overflow: hidden;
  margin-right: 14px; /* gap on the right of the graphs card */
}

.suburb-notes-col .v-card {
  border-radius: 10px;
  overflow: hidden;
  margin-left: 14px; /* gap on the left of the notes card */
}

/* Remove coloured background between the two graph cards
   (kills Vuetify's horizontal gutters inside the charts row
   and forces a white background there). */
.suburb-trends-wrapper .trend-inner-row {
  margin-left: 0;
  margin-right: 0;
  background-color: #ffffff;
}

.suburb-trends-wrapper .trend-col {
  padding-left: 0;
  padding-right: 0;
}
</style>
